<template>
    <div class="ticket-main">
         <!-- 导航栏 -->
        <van-nav-bar
            v-if="isWechat"
            title="卡券详情"
            left-text="返回"
            left-arrow
            @click-left="onGoBack"
        />
        <div class="ticket__ticket-info-wrapper">
            <van-row class="ticket__ticket-account-title-wrapper">
                <span>使用卡券</span>
            </van-row>
            <!-- 图片条形码128卡券 -->
            <van-row v-if="!!!goodsType || 'BARCODE_128' === goodsType || 'BARCODE_128_QR_CODE' === goodsType" type="flex" justify="center" class="ticket_ticket-info-barcode128-wrapper">
                <van-image width="320" height="70" :src="barcode128Pic"/>
            </van-row>
            <!-- 图片二维码券码 -->
            <van-row v-if="!!!goodsType || 'BARCODE_128_QR_CODE' === goodsType || 'QR_CODE' === goodsType" type="flex" justify="center">
                <van-image width="160" height="160" :src="qrPic"/>
            </van-row>
            <!-- 券码字符串 -->
            <van-row v-if="!!!goodsType || ('BARCODE_128' !== goodsType && 'BARCODE_128_QR_CODE' !== goodsType && 'QR_CODE' !== goodsType)" class="ticket__ticket-info-str-wrapper">
                <div class="ticket__ticket-info-str">
                    {{account}}
                </div>
            </van-row>
            <!-- 质保期 -->
            <!-- <van-row type="flex" justify="center" class="ticket__ticket-guarantee-time">
                质保期: {{guaranteeTime}}
            </van-row> -->
            <!-- 卡券的分隔符 -->
            <van-row>
                <tic-divider/>
            </van-row>
            <van-row class="ticket__ticket-warning-title-wrapper">卡券须知</van-row>
            <van-row class="ticket__ticket-warning-wrapper">
                <div v-html="instruction"></div>
                <!-- {{instruction}} -->
                <!-- 1:将兑换券给服务人员扫码即可进行兑换消费<br/> -->
                <!-- 2:适用于全国大陆境内除机场店外的所有星巴克门店，但可能存在新开门店、机具维护等原因导致暂时无法提供服务， -->
                <!-- 具体兑换情况请以门店实际经营为准。 -->
            </van-row>
        </div>
    </div> 
</template>

<script>
import {NavBar, Image, Row, Col} from "vant";
import TicketDivider from "@/components/TicketDivider.vue";
import {navMixins, wechatMixins} from "@/mixins.js";
import request from "@/utils/request.js";

export default {
    name: "Ticket",
    mixins: [navMixins, wechatMixins],
    components: {
        [NavBar.name]: NavBar,
        [Image.name]: Image,
        [Row.name]: Row,
        [Col.name]: Col,
        [TicketDivider.name]: TicketDivider
    },
    data() {
        return {
            orderNo: undefined,
            account: undefined,
            password: undefined,
            qrPic: undefined,
            barcode128Pic: undefined,
            guaranteeTime: undefined,
            instruction: undefined,
            goodsType: undefined
        };
    },
    mounted() {
        this.orderNo = this.$route.params.order_no;
        this.loadOrderAccount();
    },
    methods: {
        async loadOrderAccount() {
            const {data} = await request.get(`/customer/order/loadOrderAccount?orderNo=${this.orderNo}`);
            if (data) {
                this.account = data.account;
                this.password = data.password;
                this.guaranteeTime = data.guaranteeTime;
                this.qrPic = data.qrPic;
                this.barcode128Pic= data.barcode128;
                this.instruction = data.instruction;
                this.goodsType = data.goodsType;
            } else {
                this.account = "尚未发货";
                this.guaranteeTime = "--";
            }
        }
    }
}
</script>

<style lang="less">
@import "@/style/base.less";
.ticket-main {
    padding: 8px 0px;
    min-height: 100vh;
    background-color: @color-theme;

    .van-nav-bar {
        background-color: @color-theme;
    }
    .van-nav-bar.van-hairline--bottom::after {
        border: none;
    }

    // 导航栏文字
    .van-nav-bar__text {
        color: white;
    }

    .van-icon.van-nav-bar__arrow {
        color: white;
    }

    .van-nav-bar__title {
        color: white;
    }
}

.ticket__ticket-info-wrapper {
    border-radius: 8px;
    background-color: white;
    margin: 0px 8px 0 8px;
}

.ticket__ticket-account-title-wrapper {
    padding: 16px;
    font-size: 20px;
    line-height: 28px;
    font-weight: 500;
}
.ticket_ticket-info-barcode128-wrapper {
    padding: 16px;
}
.ticket__ticket-info-str-wrapper {
    padding: 16px;
}

.ticket__ticket-info-str {
    border: 2px solid @color-border;
    border-radius: 4px;
    text-align: center;
    padding: 16px 8px;
     word-break: break-all;
}

.ticket__ticket-guarantee-time {
    font-size: @font-size-normal;
    color: @font-color-title;
    line-height: @line-height-normal;
}

.ticket__ticket-warning-title-wrapper {
    padding: 16px 16px 8px 16px;
    font-size: 20px;
    line-height: 28px;
    font-weight: 500;
}

.ticket__ticket-warning-wrapper {
    padding: 0 16px 16px 16px;
    font-size: @font-size-normal;
    color: @font-color-normal;
    line-height: @line-height-title;
    letter-spacing: 1px;
}
</style>